'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _authentication = require('./authentication/authentication');

var _authentication2 = _interopRequireDefault(_authentication);

var _admin = require('./admin/admin');

var _admin2 = _interopRequireDefault(_admin);

var _reports = require('./reports/reports');

var _reports2 = _interopRequireDefault(_reports);

var _v = require('./v2/v2');

var _v2 = _interopRequireDefault(_v);

var _logout = require('./logout/logout');

var _logout2 = _interopRequireDefault(_logout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentModule = _angular2.default.module('app.components', [_authentication2.default.name, _admin2.default.name, _logout2.default.name, _reports2.default.name, _v2.default.name]);

exports.default = componentModule;


// WEBPACK FOOTER //
// ./client/app/components/components.js